"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeHexPrefix = exports.ensureHexPrefix = exports.denormalizeExecutionArgs = exports.ensureTronAddress = exports.ensureHexAddress = exports.isTronNativeToken = exports.normalizeExecutionResponse = exports.mapTronTxToGlobal = exports.mapTrxBlockToGlobalInterface = exports.removeNumericKeys = void 0;
const Types_1 = require("../../../Types");
const TronAddressFormat = __importStar(require("tron-format-address"));
const Tokens_1 = require("../Tokens");
function removeNumericKeys(obj) {
    const argKeys = Object.keys(obj).filter((key) => isNaN(Number(key)));
    const args = {};
    argKeys.forEach((key) => {
        args[key] = obj[key];
    });
    return args;
}
exports.removeNumericKeys = removeNumericKeys;
// todo move to ResponseNormalizer file
function mapTrxBlockToGlobalInterface(block) {
    const hash = block.blockID;
    const parentHash = block.block_header.raw_data.parentHash;
    const number = block.block_header.raw_data.number;
    const timestamp = Math.floor(Number(block.block_header.raw_data.timestamp / 1000));
    return {
        hash,
        parentHash,
        number,
        timestamp,
        transactions: (block.transactions || []).map((tx) => tx.txID),
    };
}
exports.mapTrxBlockToGlobalInterface = mapTrxBlockToGlobalInterface;
function mapTronTxToGlobal(block, tronTx) {
    const scData = tronTx.raw_data.contract[0].parameter.value;
    const receiver = scData.contract_address ||
        scData.to_address ||
        scData.account_address ||
        scData.receiver_address;
    return {
        hash: exports.ensureHexPrefix(tronTx.txID),
        value: (scData === null || scData === void 0 ? void 0 : scData.call_value) || "0",
        txFee: null,
        status: tronTx.ret[0].contractRet === "SUCCESS"
            ? Types_1.TransactionStatus.Success
            : Types_1.TransactionStatus.Failed,
        // Only if a transaction has been mined
        blockNumber: block.number,
        timestamp: block.timestamp,
        from: exports.ensureHexAddress(parseTronHexAddress(scData.owner_address)),
        to: receiver ? exports.ensureHexAddress(parseTronHexAddress(receiver)) : undefined,
        raw: tronTx.raw_data_hex, // ?:string
    };
}
exports.mapTronTxToGlobal = mapTronTxToGlobal;
function normalizeExecutionResponse(method, abi, args, res) {
    const methodDef = findMethodDefinitionOnAbi(abi, method, args);
    if (!methodDef) {
        return res;
    }
    const responseNormalizer = methodOutputNormalizer(methodDef);
    return isArrayResponse(methodDef)
        ? res.map(responseNormalizer)
        : responseNormalizer(res, 0);
}
exports.normalizeExecutionResponse = normalizeExecutionResponse;
function isArrayResponse(methodDef) {
    return methodDef.outputs.length > 1;
}
function findMethodDefinitionOnAbi(abi, method, args = []) {
    return abi.find((m) => m.name === method && m.inputs.length === args.length);
}
function getUnitaryType(type) {
    return type.replace(/\[\]/g, "");
}
function methodOutputNormalizer(methodDef) {
    return (value, index) => {
        const output = methodDef.outputs[index];
        const type = getUnitaryType(output.type);
        let normalizer = (_value) => _value.toString();
        if (type === "address") {
            normalizer = (_value) => exports.ensureHexAddress(parseTronHexAddress(_value));
        }
        return arrayRecursiveApplier(normalizer)(value);
    };
}
const isTronNativeToken = (address) => address.toLowerCase() === Tokens_1.TronNativeToken.address.toLowerCase();
exports.isTronNativeToken = isTronNativeToken;
const ensureHexAddress = (address) => {
    if (address.startsWith("0x") || exports.isTronNativeToken(address)) {
        return address;
    }
    return TronAddressFormat.toHex(address);
};
exports.ensureHexAddress = ensureHexAddress;
const ensureTronAddress = (address) => {
    if (address.startsWith("T") || exports.isTronNativeToken(address)) {
        return address;
    }
    return TronAddressFormat.fromHex(address);
};
exports.ensureTronAddress = ensureTronAddress;
const denormalizeExecutionArgs = (args, method, abi) => {
    if (!args || args.length === 0) {
        return args;
    }
    const methodDef = findMethodDefinitionOnAbi(abi, method, args);
    return args.map((arg, i) => {
        const type = getUnitaryType(methodDef.inputs[i].type);
        let denormalizer = (value) => value;
        if (type === "address") {
            denormalizer = (value) => exports.ensureTronAddress(value);
        }
        return arrayRecursiveApplier(denormalizer)(arg);
    });
};
exports.denormalizeExecutionArgs = denormalizeExecutionArgs;
const arrayRecursiveApplier = (methodToApply) => (value) => {
    if (Array.isArray(value)) {
        return value.map(arrayRecursiveApplier(methodToApply));
    }
    return methodToApply(value);
};
const parseTronHexAddress = (address) => `0x${address.substring(2)}`;
const ensureHexPrefix = (address) => address.startsWith("0x") ? address : `0x${address}`;
exports.ensureHexPrefix = ensureHexPrefix;
const removeHexPrefix = (str) => str.startsWith("0x") ? str.substring(2) : str;
exports.removeHexPrefix = removeHexPrefix;
